(() => {
  "use strict";

  const media = window.HUH_MEDIA || {};
  const plans = window.HUH_PLANS || {
    monthly: { name: "Monthly", access: 15, kit: 59, period: "month" },
    annual: { name: "Annual", access: 159, kit: 40, period: "year" },
    lifetime: { name: "Lifetime", access: 349, kit: 0, period: null }
  };
  const purchaseDialog = document.getElementById("purchase-dialog");
  const videoDialog = document.getElementById("video-dialog");
  const player = document.getElementById("active-video");
  const videoError = document.getElementById("video-error");
  const videoDownload = document.getElementById("video-download");
  const reviewsDialog = document.getElementById("reviews-dialog");
  const dialogs = [purchaseDialog, videoDialog, reviewsDialog].filter(Boolean);
  const triggers = new Map();
  let activeDialog = null;
  let savedOverflow = "";
  let loadingTimeout;

  function setText(id, text) {
    const node = document.getElementById(id);
    if (node) node.textContent = text;
  }

  function focusableElements(dialog) {
    return Array.from(dialog.querySelectorAll("a[href], button, input, select, textarea, video[controls], audio[controls], [tabindex]"))
      .filter((node) => !node.disabled && node.tabIndex >= 0 && !node.closest("[hidden]") && node.getClientRects().length);
  }

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    if (dialog.open) {
      triggers.set(dialog, trigger || document.activeElement);
      return;
    }
    if (activeDialog) closeDialog(activeDialog);
    triggers.set(dialog, trigger || document.activeElement);
    activeDialog = dialog;
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if (typeof dialog.showModal === "function") dialog.showModal();
    else {
      dialog.setAttribute("open", "");
      dialog.classList.add("is-fallback");
      dialog.setAttribute("role", "dialog");
      dialog.setAttribute("aria-modal", "true");
    }
    const closeButton = dialog.querySelector("[data-close-dialog]");
    if (closeButton) closeButton.focus();
  }

  function restoreDialog(dialog) {
    // Native close events may arrive after a second dialog has been opened.
    if (!triggers.has(dialog)) return;
    if (dialog === videoDialog && player) {
      player.pause();
      clearTimeout(loadingTimeout);
      player.setAttribute("aria-busy", "false");
    }
    if (activeDialog === dialog) {
      activeDialog = null;
      document.body.style.overflow = savedOverflow;
    }
    if (dialog.classList.contains("is-fallback")) {
      dialog.classList.remove("is-fallback");
      dialog.removeAttribute("aria-modal");
    }
    const trigger = triggers.get(dialog);
    triggers.delete(dialog);
    if (trigger && trigger.isConnected) trigger.focus();
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
    restoreDialog(dialog);
  }

  function openPlan(key, trigger) {
    if (!purchaseDialog || !Object.prototype.hasOwnProperty.call(plans, key)) return false;
    const plan = plans[key];
    const recurring = Boolean(plan.period);
    setText("purchase-title", `Crush ${plan.name.toLowerCase()}`);
    const co = document.getElementById("plan-checkout"); if (co) co.setAttribute("data-checkout-plan", key);
    setText("plan-access-label", recurring ? `Crush membership · ${plan.name.toLowerCase()}` : "Crush membership · lifetime");
    setText("plan-access-price", recurring ? `${plan.currency || "$"}${plan.access} / ${plan.period}` : `${plan.currency || "$"}${plan.access} one-time`);
    setText("plan-kit-price", plan.kit ? `${plan.currency || "$"}${plan.kit} one-time` : "Included");
    setText("plan-shipping", plan.shipping || "");
    setText("plan-total-price", `${plan.currency || "$"}${(plan.access + plan.kit).toFixed(2).replace(/\.00$/, "")}`);
    setText("plan-renewal", recurring
      ? `Then ${plan.currency || "$"}${plan.access} per ${plan.period} for your Crush membership. Hardware is a one-time purchase.`
      : "Lifetime Crush membership. No renewal payments.");
    openDialog(purchaseDialog, trigger);
    return true;
  }

  function setVideoReady() {
    clearTimeout(loadingTimeout);
    player.setAttribute("aria-busy", "false");
    if (videoError) videoError.hidden = true;
  }

  function showVideoFallback() {
    clearTimeout(loadingTimeout);
    player.setAttribute("aria-busy", "false");
    if (videoError) videoError.hidden = false;
  }

  function openVideo(key, trigger) {
    if (!player || !videoDialog || !Object.prototype.hasOwnProperty.call(media, key)) return false;
    const item = media[key];
    if (!item || !item.src) return false;
    clearTimeout(loadingTimeout);
    player.pause();
    // Local videos include their captions in the image; adding a track would duplicate them.
    player.replaceChildren();
    // Optional start offset (seconds) as a media fragment, so the first frame shown is already at that point.
    player.src = item.start ? `${item.src}#t=${item.start}` : item.src;
    player.poster = item.poster || "";
    player.classList.toggle("portrait", Boolean(item.portrait));
    videoDialog.classList.toggle("is-portrait", Boolean(item.portrait));
    player.setAttribute("aria-busy", "true");
    setText("video-title", item.title || "Heads Up Hockey video");
    setText("video-credit", item.credit || "");
    if (videoDownload) videoDownload.href = item.src;
    if (videoError) videoError.hidden = true;
    player.load();
    openDialog(videoDialog, trigger);
    loadingTimeout = setTimeout(() => {
      if (videoDialog.open && player.readyState < 2) showVideoFallback();
    }, 12000);
    const playback = player.play();
    if (playback && typeof playback.catch === "function") {
      // Autoplay restrictions leave the native Play control available.
      playback.catch(() => { if (player.error && videoDialog.open) showVideoFallback(); });
    }
    return true;
  }

  document.addEventListener("click", (event) => {
    if (!event.target || typeof event.target.closest !== "function" || event.defaultPrevented) return;
    if (activeDialog && activeDialog.classList.contains("is-fallback") && !activeDialog.contains(event.target)) {
      event.preventDefault();
      closeDialog(activeDialog);
      return;
    }
    const close = event.target.closest("[data-close-dialog]");
    if (close) { closeDialog(close.closest("dialog")); return; }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const reviews = event.target.closest("[data-reviews]");
    if (reviews && reviewsDialog) { event.preventDefault(); openDialog(reviewsDialog, reviews); return; }
    const plan = event.target.closest("[data-plan]");
    if (plan && openPlan(plan.dataset.plan, plan)) { event.preventDefault(); return; }
    const video = event.target.closest("[data-video]");
    if (video && openVideo(video.dataset.video, video)) event.preventDefault();
  });

  dialogs.forEach((dialog) => {
    dialog.addEventListener("click", (event) => { if (event.target === dialog) closeDialog(dialog); });
    dialog.addEventListener("cancel", (event) => { event.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener("close", () => { if (!dialog.open) restoreDialog(dialog); });
  });

  document.addEventListener("keydown", (event) => {
    if (!activeDialog || !activeDialog.classList.contains("is-fallback")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeDialog(activeDialog);
    } else if (event.key === "Tab") {
      const focusable = focusableElements(activeDialog);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (first && event.shiftKey && (document.activeElement === first || !activeDialog.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (first && !event.shiftKey && (document.activeElement === last || !activeDialog.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener("focusin", (event) => {
    if (activeDialog && activeDialog.classList.contains("is-fallback") && !activeDialog.contains(event.target)) {
      const first = focusableElements(activeDialog)[0];
      if (first) first.focus();
    }
  });

  if (player) {
    player.addEventListener("loadeddata", setVideoReady);
    player.addEventListener("canplay", setVideoReady);
    player.addEventListener("error", showVideoFallback);
  }

  const kitPanel = document.querySelector(".cl-product-grid");
  const unboxingStory = document.querySelector(".unboxing-story");
  if (kitPanel && unboxingStory) {
    // Match the portrait preview to the kit panel's actual height, including
    // changes from responsive text wrapping, loaded fonts and product images.
    const fitUnboxing = () => {
      unboxingStory.style.setProperty("--kit-panel-height", `${kitPanel.getBoundingClientRect().height}px`);
    };
    fitUnboxing();
    if (typeof window.ResizeObserver === "function") {
      new window.ResizeObserver(fitUnboxing).observe(kitPanel);
    } else {
      window.addEventListener("resize", fitUnboxing);
      window.addEventListener("load", fitUnboxing, { once: true });
    }
  }

  const bar = document.getElementById("purchase-bar");
  const hero = document.getElementById("top");
  const planButtons = Array.from(document.querySelectorAll("[data-plan]"));
  const closing = document.getElementById("closing-plan-cta");
  const callsToAction = [...planButtons, ...(closing ? [closing] : [])];
  if (!bar || !hero) return;

  if ("IntersectionObserver" in window) {
    let heroVisible = true;
    const visibleCallsToAction = new Map(callsToAction.map((node) => [node, false]));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (visibleCallsToAction.has(entry.target)) visibleCallsToAction.set(entry.target, entry.isIntersecting);
      });
      bar.hidden = heroVisible || Array.from(visibleCallsToAction.values()).some(Boolean);
    }, { threshold: 0 });
    [hero, ...callsToAction].forEach((node) => observer.observe(node));
  } else {
    function isVisible(node) {
      const rect = node.getBoundingClientRect();
      return rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.right > 0
        && rect.top < window.innerHeight && rect.left < window.innerWidth;
    }
    let waitingForFrame = false;
    const updateBar = () => { bar.hidden = isVisible(hero) || callsToAction.some(isVisible); };
    const scheduleUpdate = () => {
      if (waitingForFrame) return;
      waitingForFrame = true;
      window.requestAnimationFrame(() => { waitingForFrame = false; updateBar(); });
    };
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    updateBar();
  }
})();
